export const validateNewCreditLimitRegex = /^\d+$/;

export const nzProductConfigs = {
  CCNZGEM: {
    cardMaxCreditLimit: 50000,
    cardMinMonthlyPaymentPercentage: 3,
    cardMinMonthlyPaymentThreshold: 20,
  },

  CCNZOCV: {
    cardMaxCreditLimit: 50000,
    cardMinMonthlyPaymentPercentage: 3,
    cardMinMonthlyPaymentThreshold: 20,
  },

  CCNZCLN: {
    cardMaxCreditLimit: 50000,
    cardMinMonthlyPaymentPercentage: 3,
    cardMinMonthlyPaymentThreshold: 20,
  },
};

export const employmentAndIncomeTitle = "Employment and income";

export const nzMortgageMaxValue = 15000;

export const nzTotalExpensesMaxValue = 30000;

export const REFETCH_INTERVAL = 2000;
